import { Avatar, styled } from "@mui/material";
import MarkOkIcon from "components/icons/Components/MarkOkIcon";
import { nFormatter } from "../../utils/parseNumber";
import { StyledAddCollectionButton } from "../buttons/AddCollectionButton";
import profileIcon from "../icons/profileIcon.svg";

interface IProps {
  img: string | null;
  name: string;
  subscribers: number;
  isSelected: boolean;
  index: number;
  id: string;
  disabled: boolean;
  select: (id: string) => void;
  profile_icon?: string;
  selected_icon?: string;
}

const UploadNicheItem = (props: IProps) => {
  const {
    img,
    name,
    subscribers,
    id,
    select,
    isSelected,
    index,
    disabled,
    profile_icon = profileIcon,
  } = props;

  return (
    <Container
      sx={{
        borderLeft: index % 2 !== 0 ? "1px solid rgba(255,255,255, 0.14)" : "none",
        paddingRight: index % 2 === 0 ? "1rem" : "0",
        paddingLeft: index % 2 === 0 ? "0" : "1rem",
        "@media screen and (max-width: 767px)": {
          padding: "1rem 0",
          width: "100%",
          borderLeft: "none"
        }
      }}
    >
      <Info>
        <Avatar src={img ? img : ""}/>
        <InfoText>
          <p>{name}</p>
          <div style={{ width: "fit-content" }}>
            <img src={profile_icon} alt="profile"/>
            <span>{nFormatter(subscribers)}</span>
          </div>
        </InfoText>
      </Info>
      <StyledAddCollectionButton
        onClick={() => select(id)}
        isButtonActive={isSelected}
        disabled={disabled}
        sx={{
          "& svg": {
            transform: "scale(1.3)"
          }
        }}
      >
        {isSelected && <MarkOkIcon/>}
      </StyledAddCollectionButton>
    </Container>
  );
};

export default UploadNicheItem;

const Container = styled("div")({
  width: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingTop: "1rem",
  paddingBottom: "1rem"
});

const Info = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px"
});

const InfoText = styled("div")({
  display: "flex",
  flexDirection: "column",
  "& img": {
    width: "8px",
    marginRight: "4px",
    "@media screen and (max-width: 767px)": {
      width: "10px",
      position: "relative",
      top: "1px"
    },
  },
  "& span": {
    fontSize: "12px",
  },
  "& p": {
    fontSize: "14px",
    position: "relative",
    top: "2px"
  },
  "& div": {
    opacity: 0.4,
    position: "relative",
    top: "-2px"
  }
});
